import * as React from 'react';
import * as moment from 'moment';
import renderHTML from 'react-render-html';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { Link } from 'react-router-dom';
import * as _ from 'lodash';
import {
	GooglePlusShareButton,
	LinkedinShareButton,
	TwitterShareButton,
	FacebookShareButton,
	PinterestShareButton,
	FacebookIcon,
	TwitterIcon,
	GooglePlusIcon,
	LinkedinIcon,
	PinterestIcon,
} from 'react-share';
import { FacebookProvider, Comments } from 'react-facebook';
import { fetchPostWP, fetchPostsWP } from '../actions/posts';
import mapStateToProps from '../utils/mapStateToProps';
import mapDispatchToProps from '../utils/mapDispatchToProps';
import NewLetter from './component/NewLetter';
import ListPost from './component/ListPost';
import { getCookie, isEmpty } from '../helpers/index';

class Posts extends React.Component<any, any> {

	constructor(props: any) {
		super(props);
		this.state = {
			loading: true
		};
	}

	componentDidMount() {
		this.props.fetchPostsWP({
			orderby: 'date',
			order: 'desc',
			number: 100
		});
		if (this.props.match.params.post_id) {
			this.props.fetchPostWP({
				post_id: this.props.match.params.post_id
			});
		}
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.match.params.post_id != this.props.match.params.post_id) {
			window.scrollTo(110, 110);
			this.setState({
				loading: true
			});
			nextProps.fetchPostWP({
				post_id: nextProps.match.params.post_id
			});
		} else {
			if (nextProps.postsWP.loading == false || nextProps.postWP.loading == false) {
				this.setState({
					loading: false
				});
			}
		}
	}

	shouldComponentUpdate(nextProps) {
		if (nextProps.postsWP.loading || nextProps.postWP.loading) {
			return false;
		} else {
			return true;
		}
	}

	componentDidUpdate() {
		if (isEmpty(this.props.postWP.data)) {
			if(this.props.postWP.data.custom_fields.length > 0) {
				this.props.postWP.data.custom_fields.map(item => {
					if(item.key == 'seo_keyword') {
						document.title = item.value;
					}
					if(item.key == 'seo_description') {
						var metaList = document.getElementsByTagName("META");
						metaList[3].setAttribute("content", item.value);
					}
				});
			}
		}

	}

	render() {

		const { t, postsWP, postWP } = this.props;
		let tags_div = '';
		let time_div = '';
		if (isEmpty(postWP.data)) {
			time_div = moment.unix(postWP.data.post_modified.timestamp).fromNow();
			tags_div = postWP.data.terms.map((item, index) => {
				if (item.taxonomy == 'post_tag') {
					return (
						<Link to={`/tag/${item.slug}`} key={index} className="tag">{item.name}</Link>
					);
				}
			});
		}

		var category_slug = '';

		if (this.props.match.params.cate_slug) {
			category_slug = this.props.match.params.cate_slug;
		}

		let allRelatedPosts = _.filter(postsWP.data, function (post) {
			return _.some(post.terms, { 'slug': category_slug });
		});

		let filteredPosts = [];
		allRelatedPosts.map((item) => {
			if (item.post_id != this.props.match.params.post_id && filteredPosts.length < 6) {
				let storeHtml = <ListPost key={item.post_id} item={item} category_slug={category_slug} />;
				filteredPosts.push(storeHtml);
			}
		});

		var language = 'vn';

		if(getCookie('language_landing')) {
			language = getCookie('language_landing');
		}

		let filteredList = _.filter(postsWP.data, function (post) {
			return _.some(post.custom_fields, { 'value': language, 'key': 'language' });
		});

		var pagedItems = _.drop(filteredList, 0).slice(0, 5);

		let post_div = pagedItems.map((item, key) => {
			var cate_slug = 'uncategorized';
			if (item.terms.length > 0) {
				cate_slug = item.terms[0]['slug'];
			}
			return (
				<div key={key} className="post-box">
					<div className="row">
						<div className="col-sm-5">
							<div className="teaser">
								<Link to={`/post/${cate_slug}/${item.post_id}/${item.post_name}`}>
		                            <span className="imgPost">
		                              <img src={require('../img/img-maskPost370x250.png')}
		                                   style={{ background: `url(${item.post_thumbnail.link}) no-repeat center center/cover` }}/>
		                            </span>
								</Link>
							</div>
						</div>
						<div className="col-sm-7">
							<div className="meta">
								<div className="entry-title">
									<Link to={`/post/${cate_slug}/${item.post_id}/${item.post_name}`}>
										<h2><span>{item.post_title}</span></h2>
									</Link>
								</div>
							</div>
						</div>
					</div>
				</div>
			);
		});

		return (
			<div className="news listNews newsDetail">
				<div className="container">
					<div className="row">
						<div className="col-md-12 col-lg-8 columnLeft">
							<div className="post single">
								<h1 className="title font2">
									<span>{postWP.data.post_title}</span>
								</h1>
								<div className="post-meta-social-shares-container clearfix">
									{/*<div className="author-avatar-timestamp-container">
										<div className="author-name-avatar-container">
											<span className="timestamp"> <time>{time_div}</time></span>
										</div>
									</div>*/}
									<div className="regular social-shares" data-url>
										<FacebookShareButton url={window.location.href}>
											<FacebookIcon size={20} round={true}/>
										</FacebookShareButton>
										<GooglePlusShareButton url={window.location.href}>
											<GooglePlusIcon size={20} round={true}/>
										</GooglePlusShareButton>
										<TwitterShareButton url={window.location.href}>
											<TwitterIcon size={20} round={true}/>
										</TwitterShareButton>
										<PinterestShareButton url={window.location.href}>
											<PinterestIcon size={20} round={true}/>
										</PinterestShareButton>
										<LinkedinShareButton url={window.location.href}>
											<LinkedinIcon size={20} round={true}/>
										</LinkedinShareButton>
									</div>
								</div>
								<div className="content-wrapper">
									<div className="content content-responsive postContent">
										{renderHTML(`${postWP.data.post_content}`)}
									</div>
								</div>
								<div className="tags">
									{tags_div}
								</div>
								<div className="commentfb mt-2 mb-3">
									<FacebookProvider appId="525039007912592">
										<Comments href="http://www.facebook.com"/>
									</FacebookProvider>
								</div>
								<div className="related-posts">
									<h2 className="title-related font2">{t('related_posts')}</h2>
									{filteredPosts}
								</div>
							</div>
						</div>
						<div className="col-sm-4 columnRight ">
							<div className="sidebarNews">
								<div className="blockSidebar widget  mb-4 clearfix">
									<div className="widget-title">
										<h4>{t('popular')}</h4>
									</div>
									{post_div}
								</div>
								<NewLetter/>
							</div>
						</div>
					</div>
				</div>
				{this.state.loading ?
					<div className="loadingPage active"><img src={require('../img/Spin-1s-58px.gif')}/></div> : '' }
			</div>
		);
	}
}

export default connect(mapStateToProps([
	'postsWP', 'postWP'
]), mapDispatchToProps({
	fetchPostWP, fetchPostsWP
}))(translate('translations')(Posts));



// WEBPACK FOOTER //
// ./src/containers/Posts.tsx